import {useParams} from "react-router-dom";
import ExemptionPropertyDamagedForm from "../Forms/ExemptionPropertyDamagedForm/ExemptionPropertyDamagedForm";

interface FormEntry {
    formEntryId?: number;
    isAdminPreview?: boolean;
    formId?: number;
}
export default function ExemptionPropertyDamagedFormEntry(props: FormEntry): JSX.Element {
    const { isAdminPreview, formEntryId, formId } = props;
    const { formEntryIdParams } = useParams();

    return <>
        <ExemptionPropertyDamagedForm
            formId={formId}
            isAdminPreview={isAdminPreview}
            formEntryId={formEntryIdParams ? parseInt(formEntryIdParams) : formEntryId} />
    </>
}